import React, { useState, useEffect, DragEvent } from 'react';
import {
    Button,
    Box,
    Typography,
    Grid,
    Paper,
    OutlinedInput,
    InputAdornment,
    IconButton,
    Chip,
    Stack
} from '@mui/material';
import HttpHelper from '../../utils/HttpHelper';
import { useNavigate, useParams } from 'react-router-dom';
import SelectingAssessments from '../Assessments/SelectingAssessments';
import { useAssessmentManager } from '../../hooks/UseAssessmentManager';

const LinkAssessments: React.FC = () => {
    const { jobId } = useParams<{ jobId: string }>();
    const {
        assessmentsList,
        selectedAssessments,
        searchQuery,
        handleSearch,
        handleSelectAssessment,
        handleSearchChange,
        handleDrop,
        handleDragStart,
        handleDragOver,
    } = useAssessmentManager();

    const navigate = useNavigate();


    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const assessmentIds = selectedAssessments.map((assessment: any) => assessment.id);
        const data = { assessmentIds };
        const response = await HttpHelper.put(`jobs/${jobId}/assessments/add`, data);
        console.log(response);
        navigate('/manage-jobs');
    };

    return (
        <Paper sx={{ padding: '2rem', margin: '2rem', width: '100%', marginLeft: 'auto', marginRight: 'auto' }} component="form" onSubmit={handleSubmit}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>Link Assessments to the Job</Typography>
            <SelectingAssessments
                assessmentsList={assessmentsList}
                selectedAssessments={selectedAssessments}
                searchQuery={searchQuery}
                handleSearch={handleSearch}
                handleSelectAssessment={handleSelectAssessment}
                handleSearchChange={handleSearchChange}
                handleDrop={handleDrop}
                handleDragStart={handleDragStart}
                handleDragOver={handleDragOver}
                handleSubmit={handleSubmit}
            />
            <Button type="submit" variant="contained" sx={{ backgroundColor: 'var(--ttg-green)', '&:hover': { backgroundColor: 'var(--button-hover-green)' }, marginTop: 3, marginBottom: 3 }}>Create Job</Button>

        </Paper>
    );
};

export default LinkAssessments;

